import { render, staticRenderFns } from "./Article27.vue?vue&type=template&id=ddd7516c&"
import script from "./Article27.vue?vue&type=script&lang=js&"
export * from "./Article27.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports